import { RequestCancelledError } from '../_lib/errors';

const isDeliberateCancellation = (value: unknown) =>
  value instanceof RequestCancelledError;

/**
 * react-query v4 reports every query rejection through `console.error`.
 *
 * A request the app cancelled on purpose is not a failure, and a console that cries wolf
 * on every keystroke of a typeahead is a console people stop reading -- which is where
 * genuine errors have to stay visible. Only that one case is dropped; everything else is
 * passed through untouched, including real failures of a query that was later cancelled.
 */
export const queryLogger = {
  log: (...args: unknown[]) => console.log(...args),
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => {
    if (args.some(isDeliberateCancellation)) {
      return;
    }
    console.error(...args);
  },
};
